import React, { Component } from 'react'

class In extends Component {
    el = React.createRef()

    componentDidMount() {
        this.observer = new IntersectionObserver(this.handleIntersect, {
            threshold: 0.8,
        })

        this.observer.observe(this.el.current)
    }

    handleIntersect = entries => {
        const entry = entries[0]

        if (entry.isIntersecting && entry.intersectionRatio > 0) {
            this.observer.disconnect()

            this.props.cb()
        }
    }

    render() {
        const { children } = this.props

        return <div ref={this.el}>{children}</div>
    }
}

export default In
